<template>
  <div class="page-wrapper" style="padding-top: 0">
    <div v-if="bookInfo" class="tab-wrapper">
      <h3>{{bookInfo.projectName}}·{{bookInfo.roomNum}}</h3>
      <ul class="mt20">
        <li>
          <span>预订状态：</span>
          <div>{{bookInfo.reservationStatusStr}}</div>
        </li>
        <div v-if="bookInfo.signContractCode && bookInfo.reservationStatus === 4">
          <li>
            <span v-if="this.isChangeStock === 0">签约合同号：</span>
            <span v-if="this.isChangeStock === 1">转签合同号：</span>
            <div><a v-on:click="toContract()">{{bookInfo.signContractCode}}</a></div>
          </li>
        </div>

        <div v-if="bookInfo.userType == 1">
          <li>
            <span>预订人：</span>
            <div>{{bookInfo.signName}}</div>
          </li>
          <li>
            <span>预订电话：</span>
            <div>{{bookInfo.userPhone}}</div>
          </li>
          <li>
            <span>{{bookInfo.certificatesTypeStr}}号：</span>
            <div>{{bookInfo.certificatesCode}}</div>
          </li>
        </div>

        <div v-if="bookInfo.userType == 3">
          <li>
            <span>企业名称：</span>
            <div>{{bookInfo.signName}}</div>
          </li>
          <li>
            <span>企业地址：</span>
            <div>{{bookInfo.businessAddress}}</div>
          </li>
          <li>
            <span>企业资质：</span>
            <div v-if="bookInfo.businessQualificationType === 1">营业执照</div>
            <div v-if="bookInfo.businessQualificationType === 3">法人证书</div>
            <div>{{bookInfo.businessQualification}}</div>
          </li>
          <li>
            <span></span>
            <img @click.stop="showImg(item.attachmentImgUrl)" class="file-img" v-for="(item,index) in bookInfo.businessLicenseList" :src="item.attachmentImgUrl" alt="">
          </li>

          <li>
            <span>代理人：</span>
            <div>{{bookInfo.contactsName}}</div>
          </li>
          <li>
            <span>手机号：</span>
            <div>{{bookInfo.userPhone}}</div>
          </li>
          <li>
            <span>代理人身份证号：</span>
            <div>{{bookInfo.contactsIdcard}}</div>
          </li>
          <li>
            <span>代理人邮箱：</span>
            <div>{{bookInfo.contactsMail}}</div>
          </li>

          <li>
            <span>委托证明：</span>
            <img @click.stop="showImg(item.attachmentImgUrl)" class="file-img" v-for="(item,index) in bookInfo.grantAuthList" :src="item.attachmentImgUrl" alt="" >
          </li>

        </div>


        <li>
          <span>订金：</span>
          <div>{{bookInfo.depositAccount}}元</div>
        </li>
        <li>
          <span>约定月租金：</span>
          <div>{{bookInfo.houseRentPrice}}元</div>
        </li>
        <li>
          <span>约定签约日：</span>
          <div>{{bookInfo.reservationSignDate}}</div>
        </li>
        <li>
          <span>约定租期：</span>
          <div>{{bookInfo.rentStartDate}}至{{bookInfo.rentEndDate}}（{{bookInfo.rentTypeStr}}）</div>
        </li>
      </ul>
    </div>

    <div class="tab-wrapper" v-if="bookInfo.source === 1">
      <h4>预定历史</h4>
      <Timeline>
        <TimelineItem style="top:20px;left: 230px" v-for="(item,index) in bookInfoHistory" :key="index">
          <p class="time">{{item.createTime}}</p>
          <p class="content">{{item.reservationStatusStr}}</p>
        </TimelineItem>
      </Timeline>
    </div>
    <div v-else-if="bookInfo.source === 3 && reservationOrderWayVos.length > 0" class="tab-wrapper">
      <h4 class="mb16">客户了解的预订房源途径</h4>
      <div class="mb16 bookinfo-custom-ck" v-for="(item, i) in reservationOrderWayVos" :key="i">
        <Icon type="ios-checkmark"></Icon> {{item}}
      </div>
    </div>
  </div>
</template>

<script>
  import ImgShow from 'components/ImgShow/index'

  export default {
    name: "BookInfo",
    components:{
      ImgShow
    },
    props: {
      bookInfo: {
        type: Object,
        default: null
      },
      bookInfoHistory: {
        type: Array,
        default: ()=>{return []}
      },
      reservationOrderWayVos: {
        type: Array,
        default: () => {return []}
      },
      isChangeStock:{
        type: Number,
        default: 0
      }
    },
    methods:{
      showImg(src){
        this.$showImg(src)
      },
      toContract(){
        if(this.bookInfo.userType === 1){
          this.$router.push({
            name: 'personalcontractdetail',
            query: {id: this.bookInfo.signContractFid, code: this.bookInfo.signContractCode}
          })
        }
        if(this.bookInfo.userType === 3){
          let query = {
            isParent: 0,
            id: this.bookInfo.signContractFid,
            code: this.bookInfo.signContractCode,
            pid: this.bookInfo.parentContractFid,
          };
          this.$router.push({name: 'companycontractdetail', query: query})
        }


      }
    }
  }
</script>

<style scoped>
  li {
    display: flex;
    margin-bottom: 15px;

  }
  li span {
    width: 120px;
    text-align: right;
  }
  .time{
    font-size: 12px;
    position:absolute;
    margin-left: -158px;
    margin-top: 0px;
  }
  .content{
    margin-left: 8px;
  }
</style>

<style>
  .bookinfo-custom-ck .ivu-icon {
    color: #CFA868;
    margin-right: 8px;
  }

  .bookinfo-custom-ck {
    font-size: 12px;
  }
</style>
